import React from 'react';
import { Card, DefaultTheme, Typography } from '@guildeducationinc/recess';
import { PictogramProps } from '@guildeducationinc/recess/pictograms/utilities/PictogramTypes';
import Skeleton from '@src/components/Shared/Skeleton/Skeleton';
import './ContactCardWrapper.scss';

export interface ContactCardWrapperProps {
  description: string | undefined;
  heading: string | undefined;
  Icon: React.FC<PictogramProps>;
}

/**
 * @name ContactCardWrapper
 * @description A wrapper component for building a Guild support contact card.
 */
const ContactCardWrapper: React.FC<ContactCardWrapperProps> = ({
  children,
  description,
  heading,
  Icon,
}) => {
  const ContactCardWrapperPictogram = () => <Icon size={48} strokeColor={DefaultTheme.iconColor} />;

  return (
    <Skeleton count={2}>
      <Card className='contactCard'>
        <ContactCardWrapperPictogram />
        <Card.Content>
          <Typography className='padding--bottom_8' variant='h2'>
            {heading}
          </Typography>
          <Skeleton>
            <Typography className='padding--bottom_16' variant='body1'>
              {description}
            </Typography>
            {children}
          </Skeleton>
        </Card.Content>
      </Card>
    </Skeleton>
  );
};

export default ContactCardWrapper;
